import { __extends } from "tslib";
import { globus, chevronBoldDown } from '../../icons/processed';
import { Icon } from '../../primitives/icon/icon';
import { DeprecatedLinkButton } from '../../primitives/deprecated-buttons';
import { Popover } from '../../primitives/popover/popover';
import { FloaterMenu, MenuItem } from '../floater-menu/floater-menu';
import * as React from 'react';
import { namespacedClassnames } from '../../common';
var key = 'locale-picker';
var LocalePicker = /** @class */ (function (_super) {
    __extends(LocalePicker, _super);
    function LocalePicker() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isLocaleMenuOpen: false
        };
        _this.selectLocale = function (value) { return function () {
            _this.props.onChange(value);
            _this.closeLocaleMenu();
        }; };
        _this.closeLocaleMenu = function () {
            _this.setState({ isLocaleMenuOpen: false });
        };
        _this.toggleLocaleMenu = function () {
            _this.setState({ isLocaleMenuOpen: !_this.state.isLocaleMenuOpen });
        };
        return _this;
    }
    LocalePicker.prototype.render = function () {
        var _this = this;
        var className = namespacedClassnames(key);
        var props = this.props;
        var sortedLocales = props.locales.sort(function (a, b) { return props.t(a).localeCompare(props.t(b)); });
        var localeMenuItems = sortedLocales.map(function (locale) {
            var maybeDisabledLocale = props.disabledLocales && props.disabledLocales.find(function (disabledLocale) { return disabledLocale.locale === locale; });
            return (React.createElement(MenuItem, { className: namespacedClassnames("locale-item"), value: locale, key: locale, onSelect: _this.selectLocale(locale), disabled: maybeDisabledLocale && maybeDisabledLocale.message }, props.t(locale)));
        });
        var localeMenu = (React.createElement("div", { className: namespacedClassnames('locale-menu-wrapper') },
            React.createElement(FloaterMenu, null, localeMenuItems)));
        return (React.createElement("div", { className: className },
            React.createElement(Popover, { body: localeMenu, isOpen: this.state.isLocaleMenuOpen, onOuterAction: this.closeLocaleMenu },
                React.createElement(DeprecatedLinkButton, { className: namespacedClassnames('picked-locale-wrapper'), onClick: this.toggleLocaleMenu },
                    props.compact ? React.createElement(Icon, { className: 'globus-icon', icon: globus }) : null,
                    React.createElement("span", { className: namespacedClassnames('picked-locale', { compact: props.compact }), "data-value": props.value }, props.selectedT ? props.selectedT(props.value) : props.t(props.value)),
                    React.createElement(Icon, { className: 'dd-icon', icon: chevronBoldDown })))));
    };
    return LocalePicker;
}(React.PureComponent));
export { LocalePicker };
//# sourceMappingURL=locale-picker.comp.js.map